import "./Loaders.scss";

export default function PageLoader() {
  return (
    <div className="page-loader-shell" role="status" aria-live="polite">
      <div className="page-loader-orbit" aria-hidden="true">
        <span className="page-loader-ring page-loader-ring-primary" />
        <span className="page-loader-ring page-loader-ring-secondary" />
        <span className="page-loader-core">
          <span className="page-loader-dot page-loader-dot-one" />
          <span className="page-loader-dot page-loader-dot-two" />
          <span className="page-loader-dot page-loader-dot-three" />
        </span>
      </div>
    </div>
  );
}

export function SuspenseLoader() {
  return (
    <div className="suspense-loader-shell">
      <div className="page-loader-orbit" aria-hidden="true">
        <span className="page-loader-ring page-loader-ring-primary" />
        <span className="page-loader-ring page-loader-ring-secondary" />
        <span className="page-loader-core">
          <span className="page-loader-dot page-loader-dot-one" />
          <span className="page-loader-dot page-loader-dot-two" />
          <span className="page-loader-dot page-loader-dot-three" />
        </span>
      </div>
    </div>
  );
}
